<template>
    <footer class="max">
        <div class="footer_cont w1200">
            <div class="left">
                <p>地址：天津市武清开发区福源道北侧</p>
                <p>电话：400-665-0265</p>
                <p>邮编：300000</p>
                <p>Copyright © 2018 天津协和万邦保险经纪有限公司</p>
            </div>
           <div class="right">
               <img @click="$router.push({path:'/license?id=0'})" src="../../static/img/circ1.jpg" alt="">
               <!-- <img @click="skip('http://www.cbirc.gov.cn/cn/view/pages/index/index.html')" src="../../static/img/circ2.jpg" alt=""> -->
               <p @click="skip('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011402000458')">
                    <img class="imgs" src="../../static/img/beian.png" alt="" style="float:left;display:inline-block; position: relative;
            left: 0;top:5px;">
                    <span style="float:left;display:inline-block;padding-left:2px;"> 津公网安备 12011402000458号</span>
               </p>
               <!-- <p style="background:red;display:block;">
                   <img src="../../static/img/beian.png" alt="" style="float:left;display:inline-block">
                   <span  style="float:left;display:inline-block">津公网安备 12011402000458号</span>
               </p> -->
               <!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011402000458" style="display:block;text-decoration:none;height:20px;line-height:20px;"><img src="../../static/img/beian.png" style="float:left;"/><p style="display:inline-block;float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">津公网安备 12011402000458号</p></a> -->
               <p @click="$router.push({path:'/license?id=1'})">企业营业执照</p>
               <p @click="skip('https://beian.miit.gov.cn/')">津ICP备15000955号-4</p>  
           </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: '',
    data(){
        return{     
        }
    },
    methods: {
    skip (url) {
      location.href = url
    }
  }

}
</script>

<style  lang="scss" scoped>
footer{
    background: #5182c4;
    height: 245px;
    .footer_cont{
        padding: 45px 0 40px 0;
        display: flex;
        justify-content: space-between;
        color: #fffff8;
        // p{
        //     line-height: 40px;
        // }
        .left{
            p{
                line-height: 44px;
            }

        }
    .right{
        // width: 210px;
        // width: 400px;
        height:150px;
        p{
            text-align: right;
            line-height: 30px;
            cursor: pointer;
        }
        img{
            display: block;
            // padding-left: 120px;
            padding-bottom: 10px;
            position: relative;
            left: 220px;
            cursor: pointer;
        }
        p:hover{
            color: #e3391f;
        }

    }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue